// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchStateCityStats } from "../../redux/actions/orderActions";
// import { fetchCustomerList } from "../../redux/actions/customerActions";
// import DashboardLayout from "../dashboard/DashboardLayout";
// import MultiSelectDropdown from "../../Pages/Components/MultiSelectDropdown";
// import SearchBar from "../../Pages/Components/SearchBar";
// import { SlideOverPanel } from "../../Pages/Components/SlideOverPanel";
// import { useNavigate } from "react-router-dom";
// import SortableTable from "../../Pages/Components/SortableTable";
// import { getOrderList } from "../../redux/actions/orderActions";
// import { format } from "date-fns";
// import { FaArrowLeft } from "react-icons/fa";
// const CityReport = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { userInfo } = useSelector((state) => state.auth);
//     const { orders, loading, error } = useSelector((state) => state.orderList);
//      const cityStats = useSelector(
//     (state) => state.stateCityStats?.data?.city_stats || []
//   );
 
//   const rawCustomers = useSelector(
//     (state) => state.fetchCustomerList?.customers
//   );
//   const customers = Array.isArray(rawCustomers)
//     ? rawCustomers
//     : Array.isArray(rawCustomers?.data)
//     ? rawCustomers.data
//     : [];
//   const [searchText, setSearchText] = useState("");
//   const [selectedStates, setSelectedStates] = useState([]);
//   const [selectedCities, setSelectedCities] = useState([]);
//   const [selectedCityForDetail, setSelectedCityForDetail] = useState(null);
//   const [selectedStateForDetail, setSelectedStateForDetail] = useState(null);
//   const [showCustomerPanel, setShowCustomerPanel] = useState(false);


//   const [selectedClientFilters, setSelectedClientFilters] = useState([]);


//   useEffect(() => {
//     dispatch(getOrderList(userInfo.access_token));
//   }, [dispatch]);
 

//   useEffect(() => {
//     if (!userInfo?.access_token) {
//       navigate("/login");
//     } else {
//       dispatch(fetchStateCityStats(userInfo.access_token));
//       dispatch(fetchCustomerList(userInfo.access_token));
//     }
//   }, [dispatch, userInfo, navigate]);

//   const uniqueStates = [...new Set(cityStats.map((i) => i.state))];
//   const uniqueCities = [
//     ...new Set(
//       cityStats
//         .filter(
//           (stat) =>
//             selectedStates.length === 0 || selectedStates.includes(stat.state)
//         )
//         .map((i) => i.city)
//     ),
//   ];
//   const uniqueClients = [
//     ...new Set(
//       (orders || [])
//         .map((order) => order.client_name)
//         .filter((name) => name && name.trim() !== "")
//     ),
//   ];

//   const filteredData = cityStats.filter((item) => {
//     const matchSearch =
//       item.state.toLowerCase().includes(searchText.toLowerCase()) ||
//       item.city?.toLowerCase().includes(searchText.toLowerCase());

//     const matchState =
//       selectedStates.length === 0 || selectedStates.includes(item.state);
//     const matchCity =
//       selectedCities.length === 0 || selectedCities.includes(item.city);

//     return matchSearch && matchState && matchCity;
//   });

//   const customersInSelectedCity = customers.filter((c) => {
//     const matchesState =
//       c.state?.toLowerCase() === selectedStateForDetail?.toLowerCase();
//     const matchesCity =
//       c.city?.toLowerCase() === selectedCityForDetail?.toLowerCase();
//     const matchesClient =
//       selectedClientFilters.length === 0 ||
//       selectedClientFilters.includes(c.client_name);

//     return matchesState && matchesCity && matchesClient;
//   });

//   return (
//     <DashboardLayout>
//       <div className="max-w-full mx-auto px-2">
//         <div className="flex items-center space-x-3 py-4">
//           <button onClick={() => navigate(-1)} className="hover:text-gray-800">
//             <FaArrowLeft size={20} />
//           </button>
//           <h2 className="text-2xl font-bold text-amber-600 mb-1">
//             {" "}
//             City-wise Redemption Report
//           </h2>
//         </div>

//         <div className="w-2/3 flex flex-col md:flex-row items-center justify-start gap-4">
//           <SearchBar
//             value={searchText}
//             onChange={setSearchText}
//             placeholder="Search by cities"
//           />
//           <MultiSelectDropdown
//             placeholder="Filter by State"
//             options={uniqueStates.map((state) => ({
//               label: state,
//               value: state,
//             }))}
//             selectedValues={selectedStates.map((val) => ({
//               label: val,
//               value: val,
//             }))}
//             setSelectedValues={(selectedOptions) =>
//               setSelectedStates(selectedOptions.map((option) => option.value))
//             }
//           />
//           <MultiSelectDropdown
//             placeholder="Filter by City"
//             options={uniqueCities.map((city) => ({ label: city, value: city }))}
//             selectedValues={selectedCities.map((val) => ({
//               label: val,
//               value: val,
//             }))}
//             setSelectedValues={(selectedOptions) =>
//               setSelectedCities(selectedOptions.map((option) => option.value))
//             }
//           />
//         </div>

//         {(selectedStates.length > 0 || selectedCities.length > 0) && (
//           <div className="w-full flex gap-6 mt-2">
//             {selectedStates.length > 0 && (
//               <div className="">
//                 <div className="text-md font-bold text-gray-950 py-2">
//                   Selected States:
//                 </div>
//                 <div className="flex flex-wrap gap-2">
//                   {selectedStates.map((state) => (
//                     <span
//                       key={state}
//                       className="bg-amber-300 text-gray-950 px-3 py-2 rounded-full text-sm font-medium"
//                     >
//                       {state}
//                     </span>
//                   ))}
//                 </div>
//               </div>
//             )}

//             {selectedCities.length > 0 && (
//               <div className="">
//                 <div className="text-md font-bold text-gray-950 py-2">
//                   Selected Cities:
//                 </div>
//                 <div className="flex flex-wrap gap-2">
//                   {selectedCities.map((city) => (
//                     <span
//                       key={city}
//                       className="bg-amber-300 text-gray-950 px-3 py-2 rounded-full text-sm font-medium"
//                     >
//                       {city}
//                     </span>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         <div className="mt-6">
//           <SortableTable
//             columns={[
//               { key: "city", label: "City", sortable: true },
//               { key: "state", label: "State", sortable: true },
//               { key: "total_redemptions", label: "Total", sortable: true },
//               {
//                 key: "successful_redemptions",
//                 label: "Successful",
//                 sortable: true,
//               },
//               { key: "failed_redemptions", label: "Failed", sortable: true },
//               {
//                 key: "success_rate",
//                 label: "Success Rate (%)",
//                 sortable: true,
//               },
//               {
//                 key: "total_amount",
//                 label: "Total Amount (₹)",
//                 sortable: true,
//               },
//               { key: "unique_users", label: "Unique Users", sortable: true },
//               { key: "actions", label: "Actions" },
//             ]}
//             data={filteredData}
//             renderRow={(item, idx) => (
//               <tr
//                 key={idx}
//                 className="hover:bg-amber-50 hover:text-gray-950 hover:font-semibold "
//               >
//                 <td className="px-2 py-4 border-b-gray-400">{item.city}</td>
//                 <td className="py-4 px-2 border-b-gray-400">{item.state}</td>
//                 <td className="py-4 px-2 border-b-gray-400">
//                   {item.total_redemptions}
//                 </td>
//                 <td className="py-4 px-2 border-b-gray-400">
//                   {item.successful_redemptions}
//                 </td>
//                 <td className="py-4 px-2 border-b-gray-400">
//                   {item.failed_redemptions}
//                 </td>
//                 <td className="py-4 px-2 border-b-gray-400">
//                   {item.success_rate}%
//                 </td>
//                 <td className="py-4 px-2 border-b-gray-400">
//                   ₹{item.total_amount}
//                 </td>
//                 <td className="py-4 px-2 border-b-gray-400">
//                   {item.unique_users}
//                 </td>
//                 <td className="py-4 px-2 border-b-gray-400">
//                   <button
//                     onClick={() => {
//                       setSelectedCityForDetail(item.city);
//                       setSelectedStateForDetail(item.state);
//                       setShowCustomerPanel(true);
//                     }}
//                     className="bg-amber-300 text-gray-950 border border-amber-600 px-2 py-1 rounded hover:bg-amber-500 transition"
//                   >
//                     View More
//                   </button>
//                 </td>
//               </tr>
//             )}
//           />
//         </div>

//         {showCustomerPanel && (
//           <SlideOverPanel
//             title={
//               <span className="text-amber-600 font-semibold">
//                 Customers in {selectedCityForDetail}
//               </span>
//             }
//             onClose={() => {
//               setSelectedCityForDetail(null);
//               setSelectedStateForDetail(null);
//               setShowCustomerPanel(false);
//             }}
//           >
//             {/* <SlideOverPanel
//             title={`Customers in ${selectedCityForDetail}`}
//             onClose={() => {
//               setSelectedCityForDetail(null);
//               setSelectedStateForDetail(null);
//               setShowCustomerPanel(false);
//             }}
//           > */}
//             <div className="mb-4">
//               <div className="mb-4 flex justify-between items-center bg-amber-100 p-2 rounded border border-amber-500 shadow-sm">
//                 <div className="text-md font-semibold text-gray-950">
//                   Total Customers :
//                   <span className="text-amber-600 ml-2">
//                     {customersInSelectedCity.length}
//                   </span>
//                 </div>
//                 <div className="text-md font-semibold text-gray-950">
//                   Total Amount :
//                   <span className="text-amber-600">
//                     &nbsp;₹{" "}
//                     {customersInSelectedCity.reduce(
//                       (sum, c) => sum + (c.qr_amount || 0),
//                       0
//                     )}
//                   </span>
//                 </div>
//                 <MultiSelectDropdown
//                   className="w-1/3"
//                   placeholder="Filter by Client"
//                   options={uniqueClients.map((client) => ({
//                     label: client,
//                     value: client,
//                   }))}
//                   selectedValues={selectedClientFilters.map((val) => ({
//                     label: val,
//                     value: val,
//                   }))}
//                   setSelectedValues={(selectedOptions) =>
//                     setSelectedClientFilters(
//                       selectedOptions.map((option) => option.value)
//                     )
//                   }
//                 />
//               </div>
//             </div>

//             <SortableTable
//               columns={[
//                 { key: "redeemed_at", label: "Date", sortable: true },
//                 { key: "customer_name", label: "Name", sortable: true },
//                 { key: "mobile", label: "Mobile", sortable: true },
//                 { key: "client_name", label: "Client Name", sortable: true },
//                 { key: "qr_id", label: "QR Code", sortable: true },
//                 { key: "qr_amount", label: "Amount", sortable: true },
//                 { key: "status", label: "Status", sortable: true },
//               ]}
//               data={customersInSelectedCity.map((c) => ({
//                 ...c,
//                 status: c.is_successful
//                   ? "Success"
//                   : c.is_failed
//                   ? "Failed"
//                   : "Pending",
//                 redeemed_at: new Date(c.redeemed_at).toLocaleString(),
//               }))}
//               renderRow={(c, idx) => (
//                 <tr
//                   key={idx}
//                   className="hover:bg-amber-50 hover:text-gray-950 hover:font-semibold "
//                 >
//                   <td className="py-4 px-2 border-b-gray-400">
//                     {/* {format(new Date(c.redeemed_at), "dd-MM-yyyy")} */}
//                        {c.redeemed_at}
//                   </td>
//                   <td className="px-2 py-4 border-b-gray-400">
//                     {c.order_type === "promotional" ? "-" : c.customer_name}
//                   </td>
//                   <td className="px-2 py-4 border-b-gray-400">
//                     {c.order_type === "promotional" ? "-" : c.mobile}
//                   </td>

//                   <td className="py-4 px-2 border-b-gray-400">
//                     {c.client_name}
//                   </td>
//                   <td className="py-4 px-2 border-b-gray-400">{c.qr_id}</td>
//                   <td className="py-4 px-2 border-b-gray-400">
//                     ₹{c.qr_amount}
//                   </td>
//                   <td className="py-4 px-2 border-b-gray-400">{c.status}</td>
//                 </tr>
//               )}
//             />
//           </SlideOverPanel>
//         )}
//       </div>
//     </DashboardLayout>
//   );
// };

// export default CityReport;


import React, { useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "../dashboard/DashboardLayout";
import { FaArrowLeft } from "react-icons/fa";

/* ─────────────────────────────────────────
   Stat card
───────────────────────────────────────── */
const StatCard = ({ label, value, icon, border, bg, textColor, onClick, active }) => (
  <div
    onClick={onClick}
    className={`border-2 ${border} ${active ? bg.replace("50", "200") : bg}
      rounded-xl p-4 flex items-center gap-3 shadow-sm transition-all duration-200
      ${onClick ? "cursor-pointer hover:shadow-md select-none" : ""}`}
  >
    <span className="text-3xl">{icon}</span>
    <div>
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">{label}</p>
      <p className={`text-2xl font-bold ${textColor}`}>{value}</p>

    </div>
  </div>
);

/* ─────────────────────────────────────────
   Generic table
───────────────────────────────────────── */
const ListTable = ({ columns, rows, emptyMsg = "No data available.", headerBg = "bg-gray-100" }) => (
  <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
    {rows.length === 0 ? (
      <p className="text-center text-gray-400 py-8 text-sm">{emptyMsg}</p>
    ) : (
      <table className="min-w-full text-sm">
        <thead>
          <tr className={`${headerBg} text-gray-700 font-semibold text-left`}>
            {columns.map((col) => (
              <th key={col} className="px-4 py-2 border-b whitespace-nowrap">{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    )}
  </div>
);

/* ─────────────────────────────────────────
   Cities table with District column
───────────────────────────────────────── */
const CitiesTable = ({ allCities, customers, districtStats, userCountByCity }) => {
  // Build city -> district map from customers data (most accurate source)
  // customers have both city + district fields per redemption record
  const cityToDistrict = customers.reduce((acc, c) => {
    if (c.city && c.district && !acc[c.city]) {
      acc[c.city] = c.district;
    }
    return acc;
  }, {});

  // Secondary fallback: use districtStats city_count to infer
  // For each district, find cities from allCities in same state
  // and assign if city_count matches (best-effort only)
  const stateDistrictMap = districtStats.reduce((acc, d) => {
    if (!acc[d.state]) acc[d.state] = [];
    acc[d.state].push(d);
    return acc;
  }, {});

  return (
    <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
      {allCities.length === 0 ? (
        <p className="text-center text-gray-400 py-8 text-sm">No city data available.</p>
      ) : (
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-yellow-100 text-gray-700 font-semibold text-left">
              {["#", "City", "District", "State", "User Count", "Total Redemptions", "Success", "Failed", "Success Rate", "Amount"].map((col) => (
                <th key={col} className="px-4 py-2 border-b whitespace-nowrap">{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {allCities.map((c, i) => (
              <tr key={i} className="border-b hover:bg-yellow-50">
                <td className="px-4 py-3">{i + 1}</td>
                <td className="px-4 py-3 font-medium">{c.city}</td>
                <td className="px-4 py-3">
                  {(() => {
                    // 1. direct field on city object
                    if (c.district) return c.district;
                    // 2. from customers redemption records
                    if (cityToDistrict[c.city]) return cityToDistrict[c.city];
                    // 3. if state has only 1 district, assign it
                    const stateDists = stateDistrictMap[c.state] || [];
                    if (stateDists.length === 1) return stateDists[0].district;
                    return "-";
                  })()}
                </td>
                <td className="px-4 py-3">{c.state}</td>
                <td className="px-4 py-3">{userCountByCity[c.city]?.size || 0}</td>
                <td className="px-4 py-3">{c.total_redemptions}</td>
                <td className="px-4 py-3 text-green-600">{c.successful_redemptions}</td>
                <td className="px-4 py-3 text-red-500">{c.failed_redemptions}</td>
                <td className="px-4 py-3">{c.success_rate}%</td>
                <td className="px-4 py-3">Rs.{c.total_amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

/* ═══════════════════════════════════════════════════════
   MAIN DETAIL PAGE
═══════════════════════════════════════════════════════ */
const StateReportDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    cardKey,
    stateStats    = [],
    cityStats     = [],
    districtStats = [],
    customers     = [],
    summary       = {},
  } = location.state || {};

  const [activeList, setActiveList] = useState("main");

  const handleCardClick = (key) => {
    setActiveList(prev => prev === key ? "main" : key);
  };

  /* ── derived helpers ── */
  const uniqueUsers = useMemo(() => [
    ...new Map(customers.filter(c => c.mobile).map(c => [c.mobile, c])).values(),
  ], [customers]);

  const districtCountByState = useMemo(() =>
    districtStats.reduce((acc, d) => { acc[d.state] = (acc[d.state] || 0) + 1; return acc; }, {}),
  [districtStats]);

  const cityCountByState = useMemo(() =>
    cityStats.reduce((acc, c) => { if (c.city?.trim()) acc[c.state] = (acc[c.state] || 0) + 1; return acc; }, {}),
  [cityStats]);

  const userCountByState = useMemo(() =>
    customers.reduce((acc, c) => {
      if (c.state) { if (!acc[c.state]) acc[c.state] = new Set(); acc[c.state].add(c.mobile); }
      return acc;
    }, {}),
  [customers]);

  const userCountByDistrict = useMemo(() =>
    customers.reduce((acc, c) => {
      if (c.district) { if (!acc[c.district]) acc[c.district] = new Set(); acc[c.district].add(c.mobile); }
      return acc;
    }, {}),
  [customers]);

  const userCountByCity = useMemo(() =>
    customers.reduce((acc, c) => {
      if (c.city) { if (!acc[c.city]) acc[c.city] = new Set(); acc[c.city].add(c.mobile); }
      return acc;
    }, {}),
  [customers]);

  const allCities = useMemo(() => cityStats.filter(c => c.city?.trim()), [cityStats]);

  /* ── totals ── */
  const totalStates    = summary.total_states    ?? stateStats.length;
  const totalDistricts = summary.total_districts ?? districtStats.length;
  const totalCities    = summary.total_cities    ?? allCities.length;
  const totalUsers     = summary.total_unique_users_mobile ?? uniqueUsers.length;

  /* ── page config ── */
  const pageCfg = {
    states:    { title: "States",    icon: "States",    headerBg: "bg-amber-500"  },
    districts: { title: "Districts", icon: "Districts", headerBg: "bg-orange-500" },
    cities:    { title: "Cities",    icon: "Cities",    headerBg: "bg-yellow-500" },
    users:     { title: "Users",     icon: "Users",     headerBg: "bg-green-500"  },
  };
  const cfg = pageCfg[cardKey] || pageCfg.states;

  /* ── top cards per page ── */
  const topCardDefs = {
    states: [
      { key: "main",      label: "Total States",    value: totalStates,    icon: "States",    border: "border-amber-400",  bg: "bg-amber-50",  textColor: "text-amber-600"  },
      { key: "districts", label: "Total Districts", value: totalDistricts, icon: "Districts", border: "border-orange-400", bg: "bg-orange-50", textColor: "text-orange-600" },
      { key: "cities",    label: "Total Cities",    value: totalCities,    icon: "Cities",    border: "border-yellow-400", bg: "bg-yellow-50", textColor: "text-yellow-600" },
      { key: "users",     label: "Unique Users",    value: totalUsers,     icon: "Users",     border: "border-green-400",  bg: "bg-green-50",  textColor: "text-green-600"  },
    ],
    districts: [
      { key: "main",   label: "Total Districts", value: totalDistricts, icon: "Districts", border: "border-orange-400", bg: "bg-orange-50", textColor: "text-orange-600" },
      { key: "cities", label: "Total Cities",    value: totalCities,    icon: "Cities",    border: "border-yellow-400", bg: "bg-yellow-50", textColor: "text-yellow-600" },
      { key: "users",  label: "Unique Users",    value: totalUsers,     icon: "Users",     border: "border-green-400",  bg: "bg-green-50",  textColor: "text-green-600"  },
    ],
    cities: [
      { key: "main",      label: "Total Cities",    value: totalCities,    icon: "Cities",    border: "border-yellow-400", bg: "bg-yellow-50", textColor: "text-yellow-600" },
      { key: "users",     label: "Unique Users",    value: totalUsers,     icon: "Users",     border: "border-green-400",  bg: "bg-green-50",  textColor: "text-green-600"  },
      { key: "districts", label: "Total Districts", value: totalDistricts, icon: "Districts", border: "border-orange-400", bg: "bg-orange-50", textColor: "text-orange-600" },
    ],
    users: [
      { key: "main", label: "Unique Users", value: totalUsers, icon: "Users", border: "border-green-400", bg: "bg-green-50", textColor: "text-green-600" },
    ],
  };

  /* ── list renderers ── */
  const renderStatesList = () => (
    <ListTable
      headerBg="bg-amber-100"
      columns={["#", "State", "District Count", "City Count", "User Count", "Total Redemptions", "Success", "Failed", "Success Rate", "Amount"]}
      rows={stateStats.map((s, i) => (
        <tr key={i} className="border-b hover:bg-amber-50">
          <td className="px-4 py-3">{i + 1}</td>
          <td className="px-4 py-3 font-medium">{s.state}</td>
          <td className="px-4 py-3">{districtCountByState[s.state] || 0}</td>
          <td className="px-4 py-3">{cityCountByState[s.state] || 0}</td>
          <td className="px-4 py-3">{userCountByState[s.state]?.size || 0}</td>
          <td className="px-4 py-3">{s.total_redemptions}</td>
          <td className="px-4 py-3 text-green-600">{s.successful_redemptions}</td>
          <td className="px-4 py-3 text-red-500">{s.failed_redemptions}</td>
          <td className="px-4 py-3">{s.success_rate}%</td>
          <td className="px-4 py-3">Rs.{s.total_amount}</td>
        </tr>
      ))}
      emptyMsg="No state data available."
    />
  );

  const renderDistrictsList = () => (
    <ListTable
      headerBg="bg-orange-100"
      columns={["#", "District", "State", "City Count", "User Count", "Total Redemptions", "Success", "Failed", "Success Rate", "Amount"]}
      rows={districtStats.map((d, i) => (
        <tr key={i} className="border-b hover:bg-orange-50">
          <td className="px-4 py-3">{i + 1}</td>
          <td className="px-4 py-3 font-medium">{d.district || "-"}</td>
          <td className="px-4 py-3">{d.state}</td>
          <td className="px-4 py-3">{d.city_count}</td>
          <td className="px-4 py-3">{userCountByDistrict[d.district]?.size || 0}</td>
          <td className="px-4 py-3">{d.total_redemptions}</td>
          <td className="px-4 py-3 text-green-600">{d.successful_redemptions}</td>
          <td className="px-4 py-3 text-red-500">{d.failed_redemptions}</td>
          <td className="px-4 py-3">{d.success_rate}%</td>
          <td className="px-4 py-3">Rs.{d.total_amount}</td>
        </tr>
      ))}
      emptyMsg="No district data available."
    />
  );

  const renderCitiesList = () => (
    <CitiesTable
      allCities={allCities}
      customers={customers}
      districtStats={districtStats}
      userCountByCity={userCountByCity}
    />
  );

  const renderUsersList = () => (
    <ListTable
      headerBg="bg-green-100"
      columns={["#", "Name", "Mobile", "City", "District", "State", "Client"]}
      rows={uniqueUsers.map((u, i) => (
        <tr key={i} className="border-b hover:bg-green-50">
          <td className="px-4 py-3">{i + 1}</td>
          <td className="px-4 py-3 font-medium">{u.customer_name || "-"}</td>
          <td className="px-4 py-3">{u.mobile}</td>
          <td className="px-4 py-3">{u.city || "-"}</td>
          <td className="px-4 py-3">{u.district || "-"}</td>
          <td className="px-4 py-3">{u.state || "-"}</td>
          <td className="px-4 py-3">{u.client_name || "-"}</td>
        </tr>
      ))}
      emptyMsg="No user data available."
    />
  );

  /* ── resolve which list to show ── */
  const getActiveListConfig = () => {
    const key = activeList === "main" ? cardKey : activeList;
    switch (key) {
      case "states":    return { title: "States List",    headerBg: "bg-amber-500",  content: renderStatesList()    };
      case "districts": return { title: "Districts List", headerBg: "bg-orange-500", content: renderDistrictsList() };
      case "cities":    return { title: "Cities List",    headerBg: "bg-yellow-500", content: renderCitiesList()    };
      case "users":     return { title: "Users List",     headerBg: "bg-green-500",  content: renderUsersList()     };
      default:          return { title: "List",           headerBg: "bg-gray-400",   content: null                  };
    }
  };

  const activeListCfg = getActiveListConfig();

  if (!cardKey) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center min-h-screen text-gray-500">
          No data. Please go back and click a card.
        </div>
      </DashboardLayout>
    );
  }

  const cards = topCardDefs[cardKey] || [];

  return (
    <DashboardLayout>
      <div className="max-w-full mx-auto px-4 pb-10">

        {/* Header */}
        <div className="flex items-center gap-3 py-4">
          <button
            onClick={() => navigate(-1)}
            className="hover:text-gray-800 p-1 hover:bg-amber-50 rounded-lg transition"
          >
            <FaArrowLeft size={20} />
          </button>
          <div>
            <h2 className="text-2xl font-bold text-amber-600">
              {cfg.title} Overview
            </h2>

          </div>
        </div>

        {/* Top Summary Cards */}
        <div className={`grid grid-cols-2 sm:grid-cols-${cards.length} gap-4 mb-6`}>
          {cards.map((card) => (
            <StatCard
              key={card.key}
              label={card.label}
              value={card.value}
              icon={card.icon}
              border={card.border}
              bg={card.bg}
              textColor={card.textColor}
              active={activeList === card.key}
              onClick={() => handleCardClick(card.key)}
            />
          ))}
        </div>

        {/* Single Dynamic List */}
        <div className="bg-white rounded-2xl border-2 border-gray-200 shadow-sm overflow-hidden">
          <div className={`px-5 py-3 ${activeListCfg.headerBg} flex items-center gap-2`}>
            <h3 className="font-bold text-white text-lg">{activeListCfg.title}</h3>
          </div>
          <div className="p-4">
            {activeListCfg.content}
          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default StateReportDetail;